import { setupCompose as o } from "@busbud/tailwind-buddy";
import { mergeClasses as s } from "./utils/merge-classes.js";
const e = ["sm", "md", "lg", "xl"], p = o(e, s);
export {
  p as compose,
  e as screens
};
